import React from "react";
import { QuizObjectTableColumn } from "../../../../../../store/modquiz/quiz_objects/quiz-object";
import { observer } from 'mobx-react';

interface TableHeadProps {
    saveHeader: Function,
    columns: Array<QuizObjectTableColumn>;
}

const TableHead = observer(({ columns, saveHeader }: TableHeadProps) => {
    return (
        <thead>
            <tr>
                {columns.map((column: QuizObjectTableColumn, i: number) => {
                    return (
                        <th
                            key={`column-${i}`}
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            onBlur={ev => saveHeader(ev, column)}
                        >
                            {column.title}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
});

export default TableHead;
